import React from 'react';
import { situations } from '../../data/content';
export function Situation() {
  return <section className="bg-mist py-12 lg:py-20" aria-labelledby="situation-title" data-id="element-425" data-mp="31zc60p6z2jjx">
      <div className="mx-auto max-w-5xl px-5" data-id="element-426" data-mp="2nz1ctfi6wsvl">
        <h2 id="situation-title" className="text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-427" data-mp="2ny9h84olev5b">
          ¿Esto es para vos?
        </h2>

        <ul className="mt-8 grid gap-4 md:grid-cols-2 md:gap-5 lg:mt-10" data-id="element-428" data-mp="2e86n215qjb5e">
          {situations.map(s => {
          const Icon = s.icon;
          return <li key={s.title} className="flex flex-col rounded-3xl p-5 sm:p-7" style={{
            backgroundColor: "#5CD2B4",
            backgroundImage: "none"
          }} data-id="element-429" data-mp="258tf5cx9eums">
                <div className="flex items-center gap-3" data-id="element-430" data-mp="2a85yhnox9jkm">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/30 text-ink" data-id="element-431" data-mp="1v9vj7oxi7ytr">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-432" data-mp="208f7vx3hfopt" />
                  </span>
                  <h3 className="font-display text-lg font-extrabold uppercase leading-tight tracking-tight sm:text-xl" style={{
                fontWeight: "900",
                textAlign: "left",
                color: "#174A5B"
              }} data-id="element-433" data-mp="2vvfoubtfr64r">{s.title}</h3>
                </div>
                <p className="mt-4 text-[15px] leading-relaxed" style={{
              color: "#090A0A"
            }} data-id="element-434" data-mp="34wnanuermehy">{s.body}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}